import { deviceService } from './deviceService.js';

const RATINGS_CACHE_KEY = 'cmdb_user_ratings';

function getLocalRatings() {
  try {
    const raw = localStorage.getItem(RATINGS_CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

function saveLocalRatings(ratings) {
  try {
    localStorage.setItem(RATINGS_CACHE_KEY, JSON.stringify(ratings));
  } catch (e) {
    // Storage quota or private mode fallback
  }
}

export const ratingService = {
  getUserRating(movieId) {
    const ratings = getLocalRatings();
    return ratings[movieId] ? ratings[movieId].stars : null;
  },

  async rateMovie(movie, stars) {
    const token = await deviceService.getDeviceToken();
    const ratings = getLocalRatings();
    const existing = ratings[movie.id];
    const isUpdate = !!existing;

    // Calculate optimistic updated average
    let currentTotal = movie.rating * movie.ratingCount;
    let newCount = movie.ratingCount;

    if (isUpdate) {
      currentTotal = currentTotal - existing.stars + stars;
    } else {
      currentTotal += stars;
      newCount += 1;
    }

    const newAverage = Number((currentTotal / newCount).toFixed(1));

    // Save to user storage
    ratings[movie.id] = {
      stars,
      deviceToken: token,
      timestamp: Date.now()
    };
    saveLocalRatings(ratings);

    // Asynchronously dispatch to Cloudflare D1
    fetch('/api/rate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        movieId: movie.id,
        stars,
        deviceToken: token
      })
    }).catch(() => {
      // Local fallback active
    });

    return {
      success: true,
      isUpdate,
      userRating: stars,
      averageRating: newAverage,
      ratingCount: newCount
    };
  }
};
